import type { PropsWithChildren, ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import Head from 'next/head'
import type { DomainAssetsInterface } from 'shared/types/domain'
import { baseServerSideProps } from 'shared/utils/base-server-side-props'
import { withDomainAssets } from 'shared/utils/with-domain-assets'
import LoginForm from 'modules/community/components/login-form'
import Header from 'modules/header'
import { useBrand } from 'modules/white-label/contexts/brand-context'

const Login = (): ReactNode => {
  const { t } = useTranslation()

  return (
    <div className="mx-auto max-w-lg rounded-lg bg-background-secondary px-5 pt-8 pb-10 text-center shadow-lg">
      <h1>{t('login_form.title')}</h1>
      <div className="flex flex-col gap-5">
        <LoginForm />
      </div>
    </div>
  )
}

const LoginLayout = ({
  children,
  domainAssets,
}: PropsWithChildren & { domainAssets?: DomainAssetsInterface }): ReactNode => {
  const { t } = useTranslation()
  const { brand } = useBrand()
  return (
    <>
      <Head>
        <title>{t('user.profile.menu.login')}</title>
      </Head>
      <Header logoSrc={domainAssets?.logoUrl || brand.logo?.path} />
      <div className="mx-auto mt-28 max-w-8xl overflow-hidden px-5 sm:px-6 md:px-5 lg:py-9">
        {children}
      </div>
    </>
  )
}

export const getServerSideProps = withDomainAssets(baseServerSideProps)

Login.getLayout = (page: ReactNode, props: { domainAssets?: DomainAssetsInterface }) => (
  <LoginLayout domainAssets={props.domainAssets}>{page}</LoginLayout>
)

export default Login
